export default __webpack_public_path__ + "static/media/Leaf.2f99dbf2.jfif";